<template>
  <div>
    <div id="Buttons" class="mt-3 text-right animate__animated animate__fadeInDown">
      <button
        id="SeveData"
        type="submit"
        class="btn btn-success mr-1"
        dir="ltr"
        @click.prevent="
          SetDeta()
          $ResetTimer()
        "
      >
        <span class="mr-2"> ثبت اطلاعات وارد شده</span>
        <span class="fa fa fa-check"></span>
      </button>
      <button v-if="this.$route.name == 'TarifSematha'" id="btn-Cancel" data-dismiss="modal" class="btn btn-danger mr-1" dir="ltr"><span class="mr-2">انصراف</span> <span class="fa fa-reply"></span></button>
      <span v-else>
        <button
          v-if="IsBtnBack"
          id="btnCancel"
          @click.prevent="
            Back()
            $ResetTimer()
          "
          data-dismiss="modal"
          class="btn btn-danger mr-1"
          dir="ltr"
        >
          <span class="mr-2">بازگشت</span> <span class="fa fa-reply"></span>
        </button>
      </span>
      <!-- <button id="btnCancel" class="btn btn-danger mr-1"  dir="ltr" @click.prevent="test"> <span class="mr-2">test</span> <span class="fa fa-reply"></span> </button> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      IsBtnBack: true,
      List: [],
      DataAxiosPost: {
        ArryfildValue: this.DataParanet,
        Method: 'post',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      GrpId: null,
      DataAxoisCheckedIdDb: {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'DastresiDB',
        Token: this.$session.get('Token'),
        From: 'Header',
      },
      DataAxiosRow: {
        ArryfildValue: '',
        Method: 'Get',
        Action: 'DastresiDB/GettblDB',
        Token: this.$session.get('Token'),
      },
      DataAxoisGridColumns: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmDastresiDB',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      DataGrpDb: null,
      DataAddLogInformation: {
        ArryfildValue: {},
        Method: 'post',
        Action: 'UserLogInformation/b_AddRow',
        Token: this.$session.get('Token'),
      },
    }
  },
  props: ['DataParanet', 'RouteCustom', 'IsButtonBack'],
  methods: {
    Back() {
      this.$router.go(-1)
    },
    SetNew() {
      this.$store.state.renderComponentGrid = false
      this.$store.state.renderComponentTree = false
      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponentGrid = true
        this.$store.state.renderComponentTree = true
        this.$store.state.renderComponent = true
      })
    },
    Cancel() {
      document.getElementById('btnCancel').click()
      document.getElementById('btn-Cancel').click()
    },
    SetDeta() {
      // console.log("XXXXXXXXXXXX",this.DataParanet);
      if (this.$ValidForm(this.$route.name)) {
        if (this.$route.name == 'TarifSematha') {
          this.DataAxiosPost.Action = this.$route.name + '/' + 1 + ',' + this.$session.get('UserInfo').tblUserGrpId

          this.$PostData(this.DataAxiosPost)
            .then((data) => {
              if (data.status == 'Ok') {
                this.$SweetQustion('ثبت موفق', 'اطلاعات با موفقیت ثبت شد', 'success', 'ثبت جدید', 'بستن صفحه', null, this.SetNew, this.Cancel)

                this.$store.state.renderComponentGrid = false
                this.$store.state.renderComponentTree = false
                this.$store.state.renderComponent = false
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true
                  this.$store.state.renderComponentTree = true
                  this.$store.state.renderComponent = true
                })
                document.getElementById('btnCancel').click()

                //#region ثبت رویداد های سیستم
                var object = this.$store.state.objectLogInformation
                object.UserId = this.$session.get('UserInfo').tblUserId
                object.UserNameFamily = this.$session.get('UserInfo').namFam
                object.FormId = this.$route.name
                object.tblShobeId = this.$session.get('UserInfo').tblShobeId
                object.FkId = data.returnId
                object.IsDelete = 0

                for (let index = 0; index < this.$session.get('Menu').length; index++) {
                  const element = this.$session.get('Menu')[index]
                  if (element.RouteName == object.FormId) {
                    object.FormName = element.label
                  }
                }
                this.$getLocalIP().then((res) => {
                  object.IpAddress = res
                })

                this.DataAddLogInformation.ArryfildValue = object
                this.$PostData(this.DataAddLogInformation).then((datapost) => {
                  console.log(datapost)
                })
                //#endregion  ثبت رویداد های سیستم
              } else {
                if (data.eNum == 2601) {
                  this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                } else {
                  this.$SweetQustion('خطایی رخ داده است', 'در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید', 'error', 'جزئیات', 'بستن', data.msg, this.details, this.CancelEdit)
                }
                document.getElementById('btnCancel').click()
              }
            })
            .finally(() => {})
        } else if (this.$route.name == 'DetailDefineShobe') {
          const formData = new FormData()
          const object = this.$store.state.DefineShobe.Data[0]
          //  console.log(object);
          for (const property in object) {
            formData.append(property, object[property])
          }
          formData.append('ColName', 'ImgLogoShobeId')
          formData.append('UseTableName', 'tblShobe')
          formData.append('TblUserGrpId', this.$session.get('UserInfo').tblUserGrpId)
          this.DataAxiosPost.Action = 'UploadImg'
          // this.DataAxiosPost.Method="Post"
          this.DataAxiosPost.ArryfildValue = formData
          this.$PostFormData(this.DataAxiosPost).then((data) => {
            if (data.status == 'OK') {
              object.ImgLogoShobeId = data.imageId
              object.imgLogoShobe = null
              console.log(data)
            }
            console.log(object)

            this.DataAxiosPost.Action = 'DefineShobe'
            this.DataAxiosPost.ArryfildValue = object
            this.DataAxiosPost.Method = 'Post'
            console.log('savedata', object)
            this.$PostData(this.DataAxiosPost)
              .then((data) => {
                if (data.status == 'Ok') {
                  var x = JSON.parse(JSON.stringify(this.$store.state[this.$route.name.substring(6)].FixedData))
                  this.$emit('emptysaved', x)
                  this.$mySweetPost('ثبت موفق', 'اطلاعات با موفقیت ثبت شد', 'success', 'ثبت و ادامه', 'بستن صفحه')

                  //#region ثبت رویداد های سیستم
                  var object = this.$store.state.objectLogInformation
                  object.UserId = this.$session.get('UserInfo').tblUserId
                  object.UserNameFamily = this.$session.get('UserInfo').namFam
                  object.FormId = this.$route.name.substring(6)
                  object.tblShobeId = this.$session.get('UserInfo').tblShobeId
                  object.FkId = data.returnId
                  object.IsDelete = 0

                  for (let index = 0; index < this.$session.get('Menu').length; index++) {
                    const element = this.$session.get('Menu')[index]
                    if (element.RouteName == object.FormId) {
                      object.FormName = element.label
                    }
                  }
                  this.$getLocalIP().then((res) => {
                    object.IpAddress = res
                  })

                  this.DataAddLogInformation.ArryfildValue = object
                  this.$PostData(this.DataAddLogInformation).then((datapost) => {
                    console.log(datapost)
                  })
                  //#endregion  ثبت رویداد های سیستم
                  this.$ResetForm(this.$route.name)
                } else {
                  if (data.eNum == '2601') {
                    this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                  } else {
                    this.$SweetQustion('خطایی رخ داده است', 'در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید', 'warning', 'جزئیات', 'بستن', data.msg, this.details, this.CancelEdit)
                  }
                }
              })
              .finally(() => {})
          })

          //     this.$PostFormData(this.DataAxiosPost).then((data)=>{
          //         if (data.status=="Ok") {
          //               this.$mySweetPost(
          //                 "ثبت موفق",
          //                 "اطلاعات با موفقیت ثبت شد",
          //                 "success",
          //                 "ثبت و ادامه",
          //                 "بستن صفحه"
          //               );

          //                //#region ثبت رویداد های سیستم
          //             var object = this.$store.state.objectLogInformation;
          //             object.UserId = this.$session.get('UserInfo').tblUserId
          //             object.UserNameFamily = this.$session.get('UserInfo').namFam
          //             object.FormId = this.$route.name.substring(6);
          //             object.tblShobeId = this.$session.get('UserInfo').tblShobeId
          //             object.FkId = data.returnId;
          //             object.IsDelete = 0;

          //             for (let index = 0; index < this.$session.get('Menu').length; index++) {
          //               const element = this.$session.get('Menu')[index];
          //               if (element.RouteName == object.FormId) {
          //                 object.FormName = element.label
          //               }

          //             }
          //             this.$getLocalIP().then((res) => {
          //               object.IpAddress = res
          //             })

          //             this.DataAddLogInformation.ArryfildValue = object;
          //             this.$PostData(this.DataAddLogInformation).then((datapost) => {
          //               console.log(datapost);
          //             });
          //           //#endregion  ثبت رویداد های سیستم
          //         }else
          //         {
          //           if (data.eNum == "2601") {
          //             this.$mySweetDefaultTost(
          //               "خطایی رخ داده!",
          //               "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید " ,'error' ,3000);

          //           }else{
          //         this.$SweetQustion(
          //           'خطایی رخ داده است',
          //         'در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید',
          //         'warning',
          //         'جزئیات',
          //         'بستن',
          //         data.msg,
          //         this.details,
          //         this.CancelEdit);

          //           }

          //   }
          // }).finally(()=>{
          // });
        } else if (this.$route.name == 'DetailTarifKarbaran') {
          // const formData = new FormData();
          const object = this.$store.state.TarifKarbaran.Data[0]
          // for (const property in object){
          //   formData.append(property ,object[property]);

          // }
          this.DataAxiosPost.Action = 'TarifKarbaran'
          this.DataAxiosPost.ArryfildValue = object
          console.log(object)
          this.$PostData(this.DataAxiosPost)
            .then((data) => {
              if (data.status == 'Ok') {
                var x = this.$store.state[this.$route.name.substring(6)].Data[0]
                this.$emit('emptysaved', x)
                this.$mySweetPost('ثبت موفق', 'اطلاعات با موفقیت ثبت شد', 'success', 'ثبت و ادامه', 'بستن صفحه')
                //#region ثبت رویداد های سیستم
                var object = this.$store.state.objectLogInformation
                object.UserId = this.$session.get('UserInfo').tblUserId
                object.UserNameFamily = this.$session.get('UserInfo').namFam
                object.FormId = this.$route.name.substring(6)
                object.tblShobeId = this.$session.get('UserInfo').tblShobeId
                object.FkId = data.returnId
                object.IsDelete = 0

                for (let index = 0; index < this.$session.get('Menu').length; index++) {
                  const element = this.$session.get('Menu')[index]
                  if (element.RouteName == object.FormId) {
                    object.FormName = element.label
                  }
                }
                this.$getLocalIP().then((res) => {
                  object.IpAddress = res
                })

                this.DataAddLogInformation.ArryfildValue = object
                this.$PostData(this.DataAddLogInformation).then((datapost) => {
                  console.log(datapost)
                })
                //#endregion  ثبت رویداد های سیستم
                this.$ResetForm(this.$route.name)
              } else {
                if (data.eNum == '2601') {
                  this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                } else {
                  this.$SweetQustion('خطایی رخ داده است', 'در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید', 'warning', 'جزئیات', 'بستن', data.msg, this.details, this.CancelEdit)
                }
              }
            })
            .finally(() => {})
        } else {
          console.log('DataParanet', this.DataParanet)

          if (this.$route.name.substring(0, 6) == 'Detail') {
            this.DataAxiosPost.Action = this.$route.name.substring(6)
          } else {
            if (this.RouteCustom) this.DataAxiosPost.Action = this.RouteCustom
            else this.DataAxiosPost.Action = this.$route.name
          }
          var uploaders = document.getElementsByClassName('uploader')
          if (uploaders.length > 0) {
            uploaders.forEach((element) => {
              if (element.value != '') {
                console.error('if failed')
                var Datafield = element.id
                const formData = new FormData()
                formData.append('TblUserGrpId', this.$session.get('UserInfo').tblUserGrpId)
                formData.append('UseTableName', this.$route.name)
                formData.append('ColName', Datafield)
                formData.append('Image', this.$DataURIToBlob(element.value))
                var FormDataImg = { Action: '', ArryfildValue: '', Method: '' }
                FormDataImg.Action = 'UploadImg/index'
                FormDataImg.ArryfildValue = formData
                FormDataImg.Method = 'Post'
                this.$PostFormData(FormDataImg)
                  .then((data) => {
                    if (data.status == 'OK') {
                      console.clear()
                      this.DataAxiosPost.ArryfildValue[Datafield] = data.imageId
                      console.log(element, element.Id)
                      console.log(Datafield, this.DataAxiosPost.ArryfildValue[Datafield], data.imageId)
                    } else {
                      this.$mySweetDefaultTost('خطا', 'خطا در بارگذاری فایل', 'error', 2000)
                    }
                  })
                  .finally(() => {
                    console.log('finally')
                    // this.Post();
                  })
              } else {
                console.log('1')
              }
            })
            this.Post()
          } else {
            this.Post()
            console.log('2')
          }
        }
      }
    },
    details(message) {
      this.$mySweetDefault('خطای برنامه نویسی', message, 'error', false)
    },
    cancel() {
      document.getElementById('btnCancel').click()
      this.$store.state.renderComponent = false

      this.$store.state.renderComponentGrid = false
      this.$store.state.renderComponentTree = false
      this.$store.state.renderComponent = false
      this.$nextTick(() => {
        this.$store.state.renderComponentGrid = true
        this.$store.state.renderComponentTree = true
        this.$store.state.renderComponent = true
      })
    },
    Post() {
      this.DataAxiosPost.ArryfildValue = this.DataParanet
      console.log('this.$route.name', this.DataAxiosPost)
      this.$PostData(this.DataAxiosPost)
        .then((data) => {
          if (data.status == 'Ok') {
            // alert();
            this.$emit('Status', true)

            if (this.$route.name.substring(0, 6) == 'Detail') {
              var x = this.$store.state[this.$route.name.substring(6)].Data[0]
            } else {
              x = this.$store.state[this.$route.name].Data[0]
            }

            this.$emit('emptysaved', x)
            this.$mySweetPost('ثبت موفق', 'اطلاعات با موفقیت ثبت شد', 'success', 'ثبت و ادامه', 'بستن صفحه')
            //#region ثبت رویداد های سیستم
            var object = this.$store.state.objectLogInformation
            object.UserId = this.$session.get('UserInfo').tblUserId
            object.UserNameFamily = this.$session.get('UserInfo').namFam
            object.FormId = this.$route.name.substring(6)
            object.tblShobeId = this.$session.get('UserInfo').tblShobeId
            object.FkId = data.returnId
            object.IsDelete = 0

            for (let index = 0; index < this.$session.get('Menu').length; index++) {
              const element = this.$session.get('Menu')[index]
              if (element.RouteName == object.FormId) {
                object.FormName = element.label
              }
            }
            this.$getLocalIP().then((res) => {
              object.IpAddress = res
            })

            this.DataAddLogInformation.ArryfildValue = object
            this.$PostData(this.DataAddLogInformation).then((datapost) => {
              console.log(datapost)
            })
            //#endregion  ثبت رویداد های سیستم
          } else {
            console.log('error', data)
            if (data.eNum == '2601') {
              this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
            } else if (data.eNum == '1010') {
              this.$mySweetDefault('خطا ...', data.msg, 'error', 3000)
            } else {
              this.$SweetQustion('خطایی رخ داده است', 'در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید', 'warning', 'جزئیات', 'بستن', data.msg, this.details, this.CancelEdit)
            }
          }
        })
        .finally(() => {})
    },
  },
  mounted() {
    if (this.IsButtonBack == false) this.IsBtnBack = false
    else this.IsBtnBack = true
  },
}
</script>
<style scoped>
.btn {
  border-radius: 0px;
}
.spinner {
  width: 10em;
  height: 10em;
  border-top: 1em solid #6da9f5;
  border-right: 1em solid transparent;
  border-radius: 50%;
  margin: auto;
  animation: spinner 0.6s linear infinite;
}
.head {
  width: 1em;
  height: 1em;
  background-color: #6da9f5;
  border-radius: 50%;
  margin-left: 8.5em;
  margin-top: 0.5em;
}
@keyframes spinner {
  100% {
    transform: rotate(360deg);
  }
}
.btn-success {
  background: #67b221 !important;
  border: 1px solid #5ea31e !important;
}
.btn-info {
  background: #30ad95 !important;
}
.btn-secondary {
  background: #497f72 !important;
}
</style>
